<template>
	<span class="copy-btn" @click="copy">复制</span>
</template>

<script>
	export default {
		props: {
			text: {
				type: String,
				default: "",
			},
		},
		data() {
			return {

			}
		},
		methods: {
			copy() {
				// 创建输入框元素
				const input = document.createElement('input'); //不会保留文本格式
				//如果要保留文本格式，比如保留换行符，或者多行文本，可以使用  textarea 标签，再配和模板字符串 ` `
				//const input = document.createElement('textarea')
				// 将想要复制的值
				input.value = this.text;
				// 页面底部追加输入框
				document.body.appendChild(input);
				// 选中输入框
				input.select();
				// 执行浏览器复制命令
				document.execCommand('Copy');
				// 弹出复制成功信息
				this.$message.success('复制成功');
				// 复制后移除输入框
				input.remove();
			}
		}
	}
</script>

<style scoped>
	.copy-btn {
		color: #3290FD;
		cursor: pointer;
		/* font-size:15px; */
	}
</style>



// WEBPACK FOOTER //
// copy-btn.vue?6624bdf0